export default class DmsSyncStatus {
  finishedImporting!: boolean;
  pusherChannel!: string;
  pusherChannelEventName!: string;
}